import FlexPane from './_flex-pane.js'
import Text from './_text.js'

export default {
  name: 'SystemInitialisation',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'center',
        },
      },
    },
    title: {
      configSet: Text,
      configValues: {},
    },
    timeRemaining: {
      configSet: Text,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
